const projectData = [
  {
    id: 1,
    name: "find github users",
    url: "https://github-fetch-practice.netlify.app/",
    image: "/img/githubFetchProject.png",
    title: "",
  },
  {
    id: 2,
    name: "mental health fundation website",
    url: "https://mental-health-foundation.netlify.app/",
    image: "/img/screencapture-mental-health-foundation-netlify-app-2023-02-24-23_47_08.png",
    title: "",
  },
  {
    id: 3,
    name: "Apartment Project",
    url: "https://estate-project-frontend.netlify.app/",
    image: "/img/screencapture-estate-project-frontend-netlify-app-2023-01-02-00_46_13.png",
    title: "",
  },

  {
    id: 4,
    name: "YEC Leadership Talk",
    url: "https://baj-leadership.netlify.app/",
    image: "/img/screencapture-baj-leadership-netlify-app-2023-02-24-22_47_14.png",
    title: "no project",
  },
];

export default  projectData
